import { Reveal } from "@/components/motion/Reveal";

export const SectionHeading = ({ title, accent, eyebrow, right, testId }) => (
  <Reveal className="mb-10 flex flex-col gap-4 lg:mb-12 lg:flex-row lg:items-end lg:justify-between" data-testid={testId}>
    <div>
      <h2 className="font-display text-3xl font-black italic tracking-tight text-white sm:text-4xl lg:text-5xl">
        {title} {accent && <span className="text-gold glow-gold">{accent}</span>}
      </h2>
      {eyebrow && (
        <p className="mt-2 font-body text-base font-semibold tracking-[0.18em] text-white/70 md:text-lg">{eyebrow}</p>
      )}
    </div>
    {right}
  </Reveal>
);
